<template>
  <div class="home">
    <HeaderComponent screenName=""/>
    <!-- Business Banner -->
    <BannerComponent
      imageSrc="capabilities/national security/nationalsecurity-banner.jpg"
      :bannerHeadingColor="'#fff'"
      :isOverlay="true"
      heading="National Security Services"
      subheading="Protecting and Defending our Freedom"
    />

    <div class="modernization-description" data-aos="fade-up">
      <v-row>
        <v-col
          :xs="12"
        >
          <p> {{ appModernizationDesc }} </p>
        </v-col>
      </v-row>
    </div>
    <CardComponent 
      :subHeading="`BENEFITS`"
      :cardItems="benefitsItems"
    />
    <CardComponent 
      :subHeading="`CORE CAPABILITIES`"
      :cardItems="coreCapabilitiesItems"
    />
    <SectionComponent
      relatedTitle="RELATED CAPABILITIES"
      :paragraphContent="paragraphContent"
      :sections="sectionContents"
      :cards="cardData"
      :additional-content="additionalContent"
    />
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, Ref } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import BannerComponent from '@/components/BannerComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import SectionComponent from '@/components/SectionComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    BannerComponent,
    CardComponent,
    SectionComponent,
    FooterComponent
  },
  data() {
    return {
      appModernizationDesc: 'G14C provides a full range of services and solutions necessary for National Security and the Department of Defense (DoD) to satisfy its support of the nation’s military enterprise infrastructure goals with IT services throughout CONUS and OCOUNS locations. Our services include solutions necessary for DoD’s transition from service-centric information environments to the enterprise and cloud environments. The IT services and solutions we provide include application modernization, business intelligences, cloud computing, cybersecurity, DevSecOps, and digital services in support of our Intelligence Analysts, and Warfighters protecting our freedom and national security.',
      benefitsItems: [
        {
          id: 0,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'cloud-security.jpg',
          text: 'Cloud Security',
          hoverIcon: 'vector.png',
          hoverText: 'Identifying and collecting data from various virtual machines, cloud storage, and software-as-a-service (SaaS) applications performing log analysis, file carving, data recovery, and metadata analysis, to identify events and  potential threats or malicious activity.'
        },{
          id: 1,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'Agility.jpg',
          text: 'Increase Agility',
          hoverIcon: 'chart.png',
          hoverText: 'Leveraging our Agile development approach and DevSecOps capabilities to continuously integrate and continuously deliver applications and services in the Cloud infrastructure.'
        },{
          id: 2,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'innovation.jpg',
          text: 'Innovation',
          hoverIcon: 'trend-down.png',
          hoverText: 'Fosters innovation by enabling the development of new technologies, services, and business models to drive economic growth, cost effectiveness while improving quality.'
        },{
          id: 3,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'Application.jpg',
          text: 'Optimize the Application Footprint',
          hoverIcon: 'lock.png',
          hoverText: 'Balancing the portfolio of applications based on business value, technical fit, and costs ensuring the application and system footprint is optimized.'
        }
      ],
      coreCapabilitiesItems: [
        {
          id: 4,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'Application Modernization.jpg',
          text: 'Application Modernization',
          hoverIcon: 'analysis.png',
          hoverText: 'Accelerates the modernization of legacy applications, software and platforms. Provides analysis and engineering capabilities for converting, rewriting, and migrating outdated applications utilizing modern computer programming languages, architectures, software libraries, and protocols.'
        },{
          id: 5,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'Business Intelligence.jpg',
          text: 'Business Intelligence',
          hoverIcon: 'inventory.png',
          hoverText: 'Improves Healthcare Organizations with Business Intelligence capabilities so leadership can make accurate decisions based on actionable information. Our services provide military leadership with the information they need to improve processes, reporting capabilities, and situational awareness.'
        },{
          id: 6,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'cloud.jpeg',
          text: 'Cloud',
          hoverIcon: 'ai-brain.png',
          hoverText: 'Streamlines the process and approach for building, deploying, and managing applications, services, and infrastructure in the Cloud. We utilize and administer Cloud platforms, such as Amazon Web Services (AWS), Microsoft Azure, and Google Cloud Platform (GCP), to rapidly and continuously develop and deploy applications and services.'
        },{
          id: 7,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'cybersecurity.jpg',
          text: 'Cybersecurity',
          hoverIcon: 'cloud-done.png',
          hoverText: 'Strengthens capabilities for Information System Security Officer as a Service (ISSOaaS) for designing and developing cybersecurity solutions, and processes to protect Healthcare infrastructure, networks, systems, applications, and data. Our cyber experts develop and implement cyber solutions that identify, minimize, isolate and mitigate cyber threats.'
        },{
          id: 8,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'devsecops.jpg',
          text: 'DevSecOps',
          hoverIcon: 'software-license.png',
          hoverText: 'Optimizes the approach for rapidly building, deploying, and managing applications, services, and infrastructure for modernizing systems and applications. Utilizes best practices and principles to integrate security into the development and operations process to rapidly and continuously develop and deploy applications and services.'
        },{
          id: 9,
          subFolder:'capabilities', 
          folder:'health It services',
          imageUrl: 'digital-health.jpg',
          text: 'Digital Services',
          hoverIcon: 'microservices.png',
          hoverText: 'Provides DoD with a broad range of capabilities and solutions delivered electronically utilizing digital technology including Software as a Service (SaaS), Platform as a Service (PaaS), Infrastructure as a Service (IaaS), Cloud Computing, Cloud Storage and Data Services, and Digital Military Healthcare Services.'
        }
      ],
      paragraphContent: `The path to accomplishing a mission successfully commences with a comprehensive grasp of objectives, organizational ethos, and operational processes. At G14C, our commitment lies in tailoring solutions that encompass leading-edge technology, scientific advancements, and engineering expertise for our esteemed military clientele. We proudly stand as a pillar of support for National Security and the U.S. Department of Defense (DoD) in their pursuit of harnessing the utmost potential of technology. Our proven expertise in strategy formulation, diligent research, and effective problem-solving, combined with longstanding partnerships spanning decades with DoD stakeholders, underscore our unwavering commitment to excellence.`,
      sectionContents: [
        '“All the credit truly belongs to the outstanding work accomplished by the delivery team. They were dedicated to completing this effort and accomplished it through professionalism and teamwork. Your conscientiousness and skillfulness in managing and completing over hundreds of required programming tasks, as well as your patience and talent in helping provide technical assistance to all four military services is exceptional.”',
        '“I would like to extend my sincere congratulations and appreciation for your team’s efforts in earning USAACE several of the Best of AKO Awards. Thank you for your professionalism and dedication to USAACE and Fort Novosel.”',
      ],
      additionalContent: [
        'U.S. Army, HR-Command, Major General', 
        'U.S. Army Aviation, Major General', 
      ],
      cardData: [
        {
          className: 'cloud',
          color: '#7594FE',
          heading: 'Cloud',         
          link: 'cloud'
        },
        {
          className: 'devsecops',
          color: '#50E1FE',
          heading: 'Application Modernization	',
          link: 'application-modernization'
        },
        {
          className: 'security',
          color: '#E2BF66',
          heading: 'Cyber Security',
          link: 'cyber-security'
        },
        {
          className: 'devsecops',
          color: '#50E1FE',
          heading: 'DevSecOps',
          link: 'devsecops'
        },
      ]
    };
  },
  setup() {
    return {
    };
  },
});
</script>
<style scoped>
.modernization-description{
  padding: 32px;
  padding-left: 100px;
  padding-right: 100px;
}
.modernization-description div div p{
  font-size: 24px;
}
@media (max-width: 1000px) {
  .modernization-description{
    padding: 27px;
    padding-left: 80px;
    padding-right: 80px;
  }
  .modernization-description div div p{
    font-size: 24px;
  }
}
@media (max-width: 850px) {
  .modernization-description{
    padding: 22px;
    padding-left: 65px;
    padding-right: 65px;
  }
  .modernization-description div div p{
    font-size: 22px;
  }
}
@media (max-width: 750px) {
  .modernization-description{
    padding: 17px;
    padding-left: 50px;
    padding-right: 50px;
  }
  .modernization-description div div p{
    font-size: 20px;
  }
}
@media (max-width: 600px) {
  .modernization-description{
    padding: 12px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .modernization-description div div p{
    font-size: 18px;
  }
}
</style>